import { Controller } from "@hotwired/stimulus"

// 플래시 메시지를 잠시 후 자동으로 사라지게 한다.
export default class extends Controller<HTMLElement> {
  private timer?: number

  connect(): void {
    this.timer = window.setTimeout(() => this.dismiss(), 4000)
  }

  disconnect(): void {
    if (this.timer) window.clearTimeout(this.timer)
  }

  private dismiss(): void {
    this.element.style.transition = "opacity 300ms"
    this.element.style.opacity = "0"
    window.setTimeout(() => this.element.remove(), 300)
  }
}
